import { Stack, styled, TableCell, tableCellClasses } from '@mui/material'
import DownArrow from '../../../../../../assets/icons/DownArrow.png'
import UpArrow from '../../../../../../assets/icons/UpArrow.png'
import Delete from '../../../../../../assets/icons/Delete.png'
import { SortIcon, DeleteIcon } from './invoice-edit-table-actions.styles'
import {
  useDeleteLineItem,
  useSortLineItems,
} from './invoice-edit-table-actions.hooks'
import { InvoiceEditTableBodyProps } from '../invoice-edit-table-body'

type InvoiceEditTableActionstype = {
  index: number
} & InvoiceEditTableBodyProps

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white,
    // padding: '4px 12px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // padding: '4px 12px',
  },
}))

const InvoiceEditTableActions = ({
  index,
  lines,
  setLines,
}: InvoiceEditTableActionstype) => {
  const handleSorting = useSortLineItems(index, lines, setLines)
  const handleDelete = useDeleteLineItem(index, lines, setLines)

  return (
    <StyledTableCell sx={{ minWidth: 150 }}>
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
      >
        {lines.length > 1 && index === 0 && (
          <SortIcon
            src={DownArrow}
            alt="down arrow"
            onClick={() => handleSorting('DOWN')}
          />
        )}

        {lines.length > 1 && index === lines.length - 1 && (
          <SortIcon
            src={UpArrow}
            alt="up arrow"
            onClick={() => handleSorting('UP')}
          />
        )}

        {index > 0 && index < lines.length - 1 && (
          <>
            <SortIcon
              src={DownArrow}
              alt="down arrow"
              onClick={() => handleSorting('DOWN')}
            />
            <SortIcon
              src={UpArrow}
              alt="up arrow"
              onClick={() => handleSorting('UP')}
            />
          </>
        )}
        <DeleteIcon src={Delete} alt="delete" onClick={handleDelete} />
      </Stack>
    </StyledTableCell>
  )
}

export default InvoiceEditTableActions
